import React from "react";
import Layout from "../../layout/Layout";
import { dom_departureGuide } from "../../utils/keywords";
import PassengerFacilitiesAndGuideTemplate from "../../templates/passenger-facilities-and-guide/Main";
import { useSeoData } from "../../templates/seo/Main";

const DomesticDepartureGuidePage = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"Departure-Guide"}>
      <PassengerFacilitiesAndGuideTemplate keyword={dom_departureGuide} />
    </Layout>
  );
};

export default DomesticDepartureGuidePage;

export const Head = () => {
  const { meta_title, meta_description, meta_keyword } = useSeoData("departure-guide/domestic-departure");
  return (
    <>
      <title>{meta_title}</title>
      <meta name="description" content={meta_description?.data?.meta_description} />
      <meta name="keywords" content={meta_keyword?.data?.meta_keyword} />
    </>
  );
};
